import {
  Badge,
  BadgeColor,
  DetailCardSection,
  DetailList,
  DetailRow,
  formatDateTime,
  IdValue,
} from "@prequel/shared-components";

import { useProviderContext } from "@/pages/import/ProvidersPage/ProviderPage";

const ProviderDetails = () => {
  const { provider } = useProviderContext();

  return (
    <DetailCardSection title="Details">
      <DetailList>
        <DetailRow label="ID" value={<IdValue id={provider.id} />} />
        <DetailRow label="Name" value={provider.name} />
        <DetailRow
          label="Status"
          value={
            <Badge
              text={provider.is_enabled ? "Enabled" : "Disabled"}
              color={provider.is_enabled ? BadgeColor.GREEN : BadgeColor.GRAY}
            />
          }
        />
        <DetailRow label="Datalake" value={<IdValue id={provider.datalake_id} />} />
        <DetailRow
          label="Products"
          value={
            provider.products.length > 0
              ? provider.products.map((product) => (
                  <Badge key={product} text={product} color={BadgeColor.GRAY} className="mr-1" />
                ))
              : "—"
          }
        />
        {provider.machine_type_id && <DetailRow label="Machine Type" value={provider.machine_type_id} />}
        <DetailRow label="Created at" value={formatDateTime(provider.created_at)} />
        <DetailRow label="Updated at" value={formatDateTime(provider.updated_at)} />
      </DetailList>
    </DetailCardSection>
  );
};

export default ProviderDetails;
